import { AnalyticsService } from 'src/Analytics/AnalyticsService';

export const updateAnalyticsPage = (email) => {
  const category = window.location.href.replace(window.location.origin, '');
  const digitalData = {
    page: {
      pageInfo: {
        domain: document.domain,
        location: document.location,
        pageName: 'People',
        siteSection: 'People',
        pageURL: document.URL,
      },
      category: {
        primaryCategory: category.replace('/', ''),
        pageType: document.domain,
      },
    },
    user: {
      profile: {
        profileInfo: {
          loginStatus: 'logged in',
          profileID: email,
        },
      },
    },
  };

  AnalyticsService.updateDigitalData(digitalData);
  AnalyticsService.trackEvent('setAnalyticsVariables');
  AnalyticsService.trackEvent('pageLoaded');
};
